<nav class="av-list-container" aria-label="Side navigation">
    <ul class="av-list">
        @for (item of navItems(); track item.id) {
        <li class="av-list-item">
            <a class="av-list-link" [routerLink]="item.route" routerLinkActive="active">
                <span class="item-label">{{ item.labelKey | translate }}</span>
            </a>
        </li>
        }
    </ul>
</nav>
<div class="av-list-container logout-container mt-2">
    <button type="button" class="av-list-link" (click)="logout()">
        <span class="item-label">{{ 'shared.general.dialogs.logout.title' | translate }}</span>
    </button>
</div>
<div class="theme-footer py-3 d-flex justify-content-center align-items-center mt-auto">
    <app-theme-toggle></app-theme-toggle>
</div>